var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { useEffect, useState } from 'react';
import { getExtractRequestOutputById, getPreSignedFileUrls } from 'services/api/search-catalogs';
import { cacheHelper } from 'utils/cache-helper';
export function useExtractRequestOutput(requestId) {
    var _a = useState(), body = _a[0], setBody = _a[1];
    var _b = useState([]), fileUrls = _b[0], setFileUrls = _b[1];
    var _c = useState(true), filesLoading = _c[0], setFilesLoading = _c[1];
    var _d = useState(), status = _d[0], setStatus = _d[1];
    var _e = useState(true), loading = _e[0], setLoading = _e[1];
    useEffect(function () {
        (function getExtractRequests() {
            var _a, _b, _c, _d, _e, _f;
            return __awaiter(this, void 0, void 0, function () {
                var cachedResults, rsp;
                return __generator(this, function (_g) {
                    switch (_g.label) {
                        case 0:
                            setLoading(true);
                            setFilesLoading(true);
                            cachedResults = cacheHelper.getCache("outputs_".concat(requestId));
                            if (cachedResults) {
                                getPreSignedFileUrls(Object.values((_c = (_b = (_a = cachedResults.extractRequest) === null || _a === void 0 ? void 0 : _a.body) === null || _b === void 0 ? void 0 : _b.files) !== null && _c !== void 0 ? _c : {})).then(function (f) {
                                    var _a, _b;
                                    setFileUrls((_b = (_a = f.body) === null || _a === void 0 ? void 0 : _a.urls) !== null && _b !== void 0 ? _b : []);
                                    setFilesLoading(false);
                                });
                                setBody(cachedResults.extractRequest);
                                setStatus(cachedResults.status);
                                setLoading(false);
                                return [2 /*return*/];
                            }
                            return [4 /*yield*/, getExtractRequestOutputById(requestId)];
                        case 1:
                            rsp = _g.sent();
                            getPreSignedFileUrls(Object.values((_f = (_e = (_d = rsp === null || rsp === void 0 ? void 0 : rsp.body) === null || _d === void 0 ? void 0 : _d.body) === null || _e === void 0 ? void 0 : _e.files) !== null && _f !== void 0 ? _f : {})).then(function (f) {
                                var _a, _b;
                                setFileUrls((_b = (_a = f.body) === null || _a === void 0 ? void 0 : _a.urls) !== null && _b !== void 0 ? _b : []);
                                setFilesLoading(false);
                            });
                            setBody(rsp === null || rsp === void 0 ? void 0 : rsp.body);
                            setStatus(rsp.status);
                            setLoading(false);
                            cacheHelper.setCache("outputs_".concat(requestId), { extractRequest: rsp.body, status: rsp.status }, 300);
                            return [2 /*return*/];
                    }
                });
            });
        })();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return { loading: loading, status: status, body: body, fileUrls: fileUrls, filesLoading: filesLoading };
}
